module.exports = __webpack_public_path__ + "static/media/brooke-lark-158019-unsplash.cf9740e2.png";